(function () {
  'use strict';
  function parse(node, fallback) { try { return JSON.parse(node.textContent); } catch (error) { return fallback; } }
  function init(root) {
    if (root.dataset.ufeReady) return;
    root.dataset.ufeReady = 'true';
    var host = root.querySelector('[data-ufe-host]');
    var templates = Array.from(root.querySelectorAll('[data-ufe-template]'));
    function templateFor(handle) { return templates.find(function(item) { return item.dataset.ufeTemplate === handle; }); }
    if (root.dataset.mode === 'page') {
      root.querySelectorAll('[data-ufe-category]').forEach(function(example) {
        if(!example.querySelector('[data-ufe-line]'))return;
        var blueprint = example.querySelector('[data-ura-fit-blueprint]');
        function showLine(measure) {
          example.querySelectorAll('[data-ufe-line]').forEach(function(control) {
            var active = control.dataset.ufeLine === measure;
            control.setAttribute('aria-pressed', String(active));
            control.closest('[data-ufe-method]').classList.toggle('is-active', active);
          });
          if (window.URAFitBlueprint) window.URAFitBlueprint.activate(blueprint, measure, true);
        }
        example.querySelectorAll('[data-ufe-line]').forEach(function(control) {
          control.addEventListener('click', function() { showLine(control.dataset.ufeLine); });
        });
        showLine('width');
      });
      return;
    }
    var button = root.querySelector('[data-ufe-play]');
    var stage = root.querySelector('[data-ufe-stage]');
    var copy = parse(root.querySelector('[data-ufe-demo-copy]'),{});
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var unit = 'in';
    var arabicUnits = String(document.documentElement.lang || '').toLowerCase().split('-')[0] === 'ar';
    function unitLabel() { return arabicUnits ? (unit === 'in' ? 'بوصة' : 'سم') : unit; }
    var target = null;
    var current = null;
    var sample = null;
    var playing = false;
    var interacted = false;
    var raf = 0;
    var storyActive = false;
    var storyPhase = '';
    var storyProgress = null;
    function storyEase(value) {
      value = Math.max(0,Math.min(1,value));
      return value*value*(3-2*value);
    }
    function releaseStory(complete) {
      if (storyActive || complete === true) {
        stop();
        if (target && current && sample) { update('width',target.width); update('length',target.length); }
      }
      storyActive = false;
      storyPhase = '';
      storyProgress = null;
      root.removeAttribute('data-ufe-story-active');
      root.removeAttribute('data-ufe-story-phase');
    }
    function manualControl(source) {
      interacted = true;
      root.dataset.ufeStoryManual = 'true';
      releaseStory();
      root.dispatchEvent(new CustomEvent('ura:fit-story-interaction', {
        bubbles: true, detail: { source: source }
      }));
    }
    function announceStoryReady() {
      if (root.dataset.mode !== 'home') return;
      var available = Boolean(target && current && sample);
      root.dataset.ufeStoryReady = String(available);
      root.dispatchEvent(new CustomEvent('ura:fit-story-ready', {
        bubbles: true, detail: { available: available }
      }));
    }
    function renderStory(event) {
      if (root.dataset.mode !== 'home') return;
      var detail = event.detail || {};
      if (detail.active === false) { releaseStory(detail.complete); return; }
      if (detail.active !== true || interacted || reduce.matches || document.hidden || !target || !current || !sample) return;
      var progress = Number(detail.progress);
      if (!Number.isFinite(progress)) return;
      progress = Math.max(0,Math.min(1,progress));
      if (!storyActive) {
        stop();
        storyActive = true;
        root.dataset.ufeStoryActive = 'true';
      }
      if (progress === storyProgress) return;
      storyProgress = progress;
      update('width',target.width-2.54+2.54*storyEase(progress/.4));
      update('length',target.length-2.54+2.54*storyEase((progress-.4)/.38));
      var phase = progress < .4 ? 'width' : progress < .78 ? 'length' : 'result';
      if (phase !== storyPhase) {
        storyPhase = phase;
        root.dataset.ufeStoryPhase = phase;
        stage.textContent = copy[phase] || copy.ready;
        focusMeasure(phase === 'width' ? 'width' : 'length');
      }
    }
    root.addEventListener('ura:fit-story',renderStory);
    root.addEventListener('ura:fit-story-resume',function () {
      if (root.dataset.mode !== 'home' || reduce.matches) return;
      releaseStory();
      interacted = false;
      root.removeAttribute('data-ufe-story-manual');
    });
    function focusMeasure(kind) {
      if (!sample) return;
      var blueprint = sample.querySelector('[data-ura-fit-blueprint]');
      if (blueprint && window.URAFitBlueprint) window.URAFitBlueprint.activate(blueprint,kind,false);
      sample.querySelectorAll('[data-ufe-control]').forEach(function(control) {
        control.classList.toggle('is-measuring',control.dataset.ufeControl===kind);
      });
    }
    function stop() {
      cancelAnimationFrame(raf);
      playing = false;
      root.classList.remove('is-playing');
      button.textContent = button.dataset.labelReplay;
      button.setAttribute('aria-pressed','false');
    }
    function display(cm) { return (unit === 'in' ? cm/2.54 : cm).toFixed(1)+' '+unitLabel(); }
    function update(kind,value) {
      current[kind] = value;
      sample.querySelector('[data-ufe-value="'+kind+'"]').textContent = display(value);
      var minimum = target[kind]-6.35;
      var position = Math.max(0,Math.min(100,(value-minimum)/12.7*100));
      var rail = sample.querySelector('[data-ufe-ruler="'+kind+'"]').parentElement;
      rail.style.setProperty('--ura4-position','50%');
      rail.style.setProperty('--ura4-tape-offset',(50-position)+'%');
    }
    function draw() {
      ['width','length'].forEach(function(kind) {
        var scale = unit === 'in' ? 2.54 : 1;
        var minimum = (target[kind]-6.35)/scale;
        var maximum = (target[kind]+6.35)/scale;
        var increment = unit === 'in' ? .125 : .5;
        var every = unit === 'in' ? 8 : 10;
        var extension = (maximum-minimum)/2;
        var fragment = document.createDocumentFragment();
        var first = Math.ceil(Math.max(0,minimum-extension)/increment);
        var last = Math.floor((maximum+extension)/increment);
        for (var index=first;index<=last;index++) {
          var value = index*increment;
          var tick = document.createElement('span');
          var major = index%every===0;
          tick.className = 'ura4-fit__tick'+(major?' is-major':index%2===0?' is-mid':'');
          tick.style.left = ((value-minimum)/(maximum-minimum)*100)+'%';
          if (major) { var label=document.createElement('b'); label.textContent=String(Math.round(value)); tick.appendChild(label); }
          fragment.appendChild(tick);
        }
        sample.querySelector('[data-ufe-ruler="'+kind+'"]').replaceChildren(fragment);
        update(kind,current[kind]);
      });
      sample.querySelectorAll('[data-ufe-unit]').forEach(function(control) { var active=control.dataset.ufeUnit===unit; control.classList.toggle('is-active',active); control.setAttribute('aria-pressed',String(active)); });
    }
    function play() {
      if (!target) return;
      stop();
      update('width',target.width-2.54);
      update('length',target.length-2.54);
      if (reduce.matches) { update('width',target.width); update('length',target.length); stage.textContent=copy.result; focusMeasure('length'); return; }
      playing=true;
      root.classList.add('is-playing');
      button.textContent=button.dataset.labelPause;
      button.setAttribute('aria-pressed','true');
      var started=performance.now(), phase='';
      function ease(t) { t=Math.max(0,Math.min(1,t)); return t*t*(3-2*t); }
      function tick(now) {
        if (!root.isConnected) { stop(); return; }
        var elapsed=now-started;
        var next=elapsed<3200?'width':elapsed<5100?'length':'result';
        if(next!==phase) { phase=next; stage.textContent=copy[phase]; focusMeasure(phase==='width'?'width':'length'); }
        if(elapsed>=600 && elapsed<=3200) update('width',target.width-2.54+2.54*ease((elapsed-600)/2000));
        if(elapsed>=3200 && elapsed<=5500) update('length',target.length-2.54+2.54*ease((elapsed-3200)/1900));
        if(elapsed>=8000) { update('width',target.width); update('length',target.length); stop(); return; }
        raf=requestAnimationFrame(tick);
      }
      raf=requestAnimationFrame(tick);
    }
    function chooseSample(handle,run) {
      var template=templateFor(handle);
      if(!template) return;
      stop();
      host.replaceChildren(template.content.cloneNode(true));
      sample=host.querySelector('[data-ufe-sample]');
      var data=parse(sample.querySelector('[data-ufe-sample-data]'),{});
      var units=String(data.unit||'').toLowerCase();
      var factor=['in','inch','inches'].includes(units)?2.54:units==='cm'?1:0;
      var width=Number(data.width)*factor,length=Number(data.length)*factor;
      target=(data.verified===true || data.illustrative===true) && width>0 && length>0 && Number.isFinite(width) && Number.isFinite(length)?{width:width,length:length}:null;
      button.disabled=!target;
      var productLink=root.querySelector('[data-ufe-product-link]');
      productLink.hidden=!sample.dataset.productUrl;
      if(sample.dataset.productUrl) productLink.href=sample.dataset.productUrl;
      root.querySelectorAll('[data-ufe-example]').forEach(function(control) { var active=control.dataset.ufeExample===handle; control.classList.toggle('is-active',active); control.setAttribute('aria-pressed',String(active)); });
      stage.textContent=copy.ready;
      var blueprint=sample.querySelector('[data-ura-fit-blueprint]');
      if(blueprint && window.URAFitBlueprint) window.URAFitBlueprint.init(blueprint);
      focusMeasure('width');
      if(!target) { current=null; announceStoryReady(); return; }
      current={width:target.width-2.54,length:target.length-2.54};
      draw();
      sample.querySelectorAll('[data-ufe-unit]').forEach(function(control) { control.addEventListener('click',function() { manualControl('unit'); stop(); unit=control.dataset.ufeUnit; draw(); }); });
      if(run) play();
      else button.textContent=button.dataset.labelPlay;
      announceStoryReady();
    }
    root.querySelectorAll('[data-ufe-example]').forEach(function(control) { control.addEventListener('click',function() { manualControl('garment'); chooseSample(control.dataset.ufeExample,true); }); });
    button.addEventListener('click',function() { manualControl('play'); if(playing) stop(); else play(); });
    var guideScope=root.closest('.uhr-fit')||root;
    guideScope.addEventListener('ura:measure-guide',function(event){manualControl('guide');stop();focusMeasure(event.detail.measure);stage.textContent=copy[event.detail.measure]||copy.ready;});
    var first=root.querySelector('[data-ufe-example]');
    if(first) chooseSample(first.dataset.ufeExample,false);
    document.addEventListener('visibilitychange',function() {
      if(document.hidden) { releaseStory(); if(playing) stop(); }
    });
    reduce.addEventListener('change',function() {
      if(!reduce.matches) return;
      releaseStory();
      if(playing) stop();
      if(target && current && sample) {
        update('width',target.width); update('length',target.length);
        stage.textContent=copy.result; focusMeasure('length');
      }
    });
    if('IntersectionObserver' in window) {
      var seen=false;
      var observer=new IntersectionObserver(function(entries) { entries.forEach(function(entry) {
        if(entry.isIntersecting && !seen) { seen=true; if(!interacted && !storyActive && !root.hasAttribute('data-ufe-story-managed') && !reduce.matches) play(); }
        if(!entry.isIntersecting && playing) stop();
      }); },{threshold:.35});
      observer.observe(root);
    }
  }
  function ready() { document.querySelectorAll('[data-ufe]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ready,{once:true}); else ready();
  document.addEventListener('shopify:section:load',ready);
}());



